import React, { useState, useEffect } from 'react';
import {
  Menu,
  MenuItem,
  Divider,
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  IconButton,
  Tooltip,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Typography,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Checkbox
} from '@mui/material';
import * as XLSX from 'xlsx';
import TomaMuestra from './TomaMuestra';
// Temporalmente removemos las dependencias problemáticas

const KanbanTomaMuestrasInternal = () => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;

  // Estados principales
  const [muestras, setMuestras] = useState([]);
  const [estadosDisponibles, setEstadosDisponibles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [busqueda, setBusqueda] = useState('');

  // Funciones para manejar localStorage
  const getColumnasVisiblesFromStorage = () => {
    try {
      const saved = localStorage.getItem('kanban-columnas-visibles');
      return saved ? JSON.parse(saved) : [8, 3, 5]; // Default: Ausente, Toma Realizada, Verificada
    } catch (error) {
      console.error('Error al leer columnas visibles del localStorage:', error);
      return [8, 3, 5];
    }
  };

  const saveColumnasVisibleToStorage = (columnas) => {
    try {
      localStorage.setItem('kanban-columnas-visibles', JSON.stringify(columnas));
      console.log('Configuración de columnas guardada:', columnas);
      
      // Mostrar notificación temporal
      setConfigGuardada(true);
      setTimeout(() => setConfigGuardada(false), 2000);
    } catch (error) {
      console.error('Error al guardar columnas visibles en localStorage:', error);
    }
  };

  // Función para limpiar configuración (opcional, para debugging)
  const limpiarConfiguracion = () => {
    try {
      localStorage.removeItem('kanban-columnas-visibles');
      setColumnasVisibles([8, 3, 5]); // Resetear a default
      console.log('Configuración de columnas restablecida');
    } catch (error) {
      console.error('Error al limpiar configuración:', error);
    }
  };

  const [columnasVisibles, setColumnasVisibles] = useState(() => getColumnasVisiblesFromStorage());

  // Estados de filtros - usar Date nativo con inicialización segura
  const [fechaInicio, setFechaInicio] = useState(() => {
    try {
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      return hoy;
    } catch (error) {
      console.error('Error al inicializar fecha inicio:', error);
      return new Date();
    }
  });
  
  const [fechaFin, setFechaFin] = useState(() => {
    try {
      const hoy = new Date();
      hoy.setHours(23, 59, 59, 999);
      return hoy;
    } catch (error) {
      console.error('Error al inicializar fecha fin:', error);
      return new Date();
    }
  });

  // Estados UI
  const [anchorEl, setAnchorEl] = useState(null);
  const [configGuardada, setConfigGuardada] = useState(false);

  // Estados para el modal de TomaMuestra
  const [openTomaMuestra, setOpenTomaMuestra] = useState(false);
  const [selectedOrdenTrabajo, setSelectedOrdenTrabajo] = useState(null);
  const [selectedDetalles, setSelectedDetalles] = useState([]);

  // Estados para auto-actualización
  const [autoActualizar, setAutoActualizar] = useState(true);
  const [intervaloSegundos, setIntervaloSegundos] = useState(10);
  const [tiempoRestante, setTiempoRestante] = useState(10);

  // Estados para modal de detalle por estado
  const [modalDetalleEstadoOpen, setModalDetalleEstadoOpen] = useState(false);
  const [estadoSeleccionadoDetalle, setEstadoSeleccionadoDetalle] = useState(null);
  const [muestrasDetalleEstado, setMuestrasDetalleEstado] = useState([]);
  const [muestrasDetalleCompletas, setMuestrasDetalleCompletas] = useState([]);

  // Estados para modal de historial de muestra individual
  const [modalHistorialMuestraOpen, setModalHistorialMuestraOpen] = useState(false);
  const [historialMuestraSeleccionada, setHistorialMuestraSeleccionada] = useState([]);
  const [datosMuestraHistorial, setDatosMuestraHistorial] = useState(null);
  
  // Estados para filtros del modal de detalle
  const [filtros, setFiltros] = useState({
    modulo: '',
    colaborador: '',
    responsableSeguimiento: '',
    tipoMuestra: '',
    criterioIncumple: '',
    paciente: '',
    orden: '',
    cubiculo: '',
    sucursal: ''
  });
  
  // Estados para datos adicionales
  const [colaboradores, setColaboradores] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [tiposMuestra, setTiposMuestra] = useState([]);
  const [criteriosIncumplimiento, setCriteriosIncumplimiento] = useState([]);
  const [cargandoDatosCompletos, setCargandoDatosCompletos] = useState(false);

  // Definición de todas las columnas disponibles
  const columnasDisponibles = [
    { id: 'numero', label: '#', enabled: true },
    { id: 'idMuestra', label: 'ID', enabled: true },
    { id: 'orden', label: 'Orden', enabled: true },
    { id: 'paciente', label: 'Paciente', enabled: true },
    { id: 'telefono', label: 'Teléfono', enabled: false },
    { id: 'tipoMuestra', label: 'Tipo Muestra', enabled: true },
    { id: 'modulo', label: 'Módulo', enabled: true },
    { id: 'cantidadAnalisis', label: 'Cantidad Análisis', enabled: false },
    { id: 'detalleAnalisis', label: 'Detalle Análisis', enabled: false },
    { id: 'estadoAnterior', label: 'Estado Anterior', enabled: true },
    { id: 'estadoActual', label: 'Estado Actual', enabled: true },
    { id: 'estadoSiguiente', label: 'Estado Siguiente', enabled: true },
    { id: 'colaborador', label: 'Colaborador', enabled: true },
    { id: 'responsable', label: 'Responsable', enabled: true },
    { id: 'cubiculo', label: 'Cubículo', enabled: true },
    { id: 'sucursal', label: 'Sucursal', enabled: false },
    { id: 'fechaAnterior', label: 'Fecha Anterior', enabled: false },
    { id: 'fechaActual', label: 'Fecha Actual', enabled: false },
    { id: 'fechaSiguiente', label: 'Fecha Siguiente', enabled: false },
    { id: 'tiempo', label: 'Tiempo (min)', enabled: true },
    { id: 'criterioIncumple', label: 'Criterio Incumple', enabled: false },
    { id: 'comentarios', label: 'Comentarios', enabled: true },
    { id: 'fechaIngreso', label: 'Fecha Ingreso', enabled: false },
    { id: 'acciones', label: 'Acciones', enabled: true }
  ];

  // Estado para las columnas seleccionadas
  const getColumnasSeleccionadasFromStorage = () => {
    try {
      const saved = localStorage.getItem('kanban-columnas-tabla-detalle');
      if (saved) {
        return JSON.parse(saved);
      }
      // Por defecto, retornar las columnas habilitadas
      return columnasDisponibles.filter(col => col.enabled).map(col => col.id);
    } catch (error) {
      console.error('Error al leer columnas seleccionadas:', error);
      return columnasDisponibles.filter(col => col.enabled).map(col => col.id);
    }
  };

  const [columnasSeleccionadas, setColumnasSeleccionadas] = useState(() => getColumnasSeleccionadasFromStorage());
  const [anchorElColumnas, setAnchorElColumnas] = useState(null);

  // Obtener estados disponibles
  useEffect(() => {
    fetchEstados();
  }, []);

  // Obtener muestras cuando cambien los filtros
  useEffect(() => {
    fetchMuestras();
  }, [fechaInicio, fechaFin]);

  // Buscar con delay cuando cambie el texto de búsqueda
  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      fetchMuestras();
    }, 500);

    return () => clearTimeout(delayedSearch);
  }, [busqueda]);

  // Auto-actualización
  useEffect(() => {
    let intervalId;
    let countdownId;

    if (autoActualizar) {
      // Configurar el intervalo principal de actualización
      intervalId = setInterval(() => {
        actualizarTodo();
        setTiempoRestante(intervaloSegundos); // Reiniciar contador
      }, intervaloSegundos * 1000);

      // Configurar el contador regresivo
      countdownId = setInterval(() => {
        setTiempoRestante(prev => {
          if (prev <= 1) {
            return intervaloSegundos;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (countdownId) clearInterval(countdownId);
    };
  }, [autoActualizar, intervaloSegundos]);

  // Resetear el tiempo restante cuando cambie el intervalo
  useEffect(() => {
    setTiempoRestante(intervaloSegundos);
  }, [intervaloSegundos]);

  const fetchEstados = async () => {
    try {
      const response = await fetch(`${server}/mg_estados_toma_muestras`, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const estados = data.$values || data;
        setEstadosDisponibles(estados);
      }
    } catch (error) {
      console.error('Error al obtener estados:', error);
    }
  };

  // Función para actualizar todos los datos
  const actualizarTodo = async () => {
    setLoading(true);
    try {
      await Promise.all([
        fetchEstados(),
        fetchMuestras()
      ]);
    } catch (error) {
      console.error('Error al actualizar datos:', error);
    } finally {
      setLoading(false);
    }
  };

  // Función para cambiar el intervalo de auto-actualización
  const handleCambiarIntervalo = (nuevoIntervalo) => {
    setIntervaloSegundos(nuevoIntervalo);
    setTiempoRestante(nuevoIntervalo);
  };

  // Función para toggle de auto-actualización
  const toggleAutoActualizar = () => {
    setAutoActualizar(prev => {
      const nuevoEstado = !prev;
      if (nuevoEstado) {
        setTiempoRestante(intervaloSegundos);
      }
      return nuevoEstado;
    });
  };

  // Funciones auxiliares para manejar fechas de manera segura
  const formatDateForInput = (date) => {
    try {
      if (!date || isNaN(date.getTime())) {
        return new Date().toISOString().slice(0, 16);
      }
      return date.toISOString().slice(0, 16);
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return new Date().toISOString().slice(0, 16);
    }
  };

  const handleFechaInicioChange = (e) => {
    try {
      const nuevaFecha = new Date(e.target.value);
      if (!isNaN(nuevaFecha.getTime())) {
        setFechaInicio(nuevaFecha);
      }
    } catch (error) {
      console.error('Error al cambiar fecha inicio:', error);
    }
  };

  const handleFechaFinChange = (e) => {
    try {
      const nuevaFecha = new Date(e.target.value);
      if (!isNaN(nuevaFecha.getTime())) {
        setFechaFin(nuevaFecha);
      }
    } catch (error) {
      console.error('Error al cambiar fecha fin:', error);
    }
  };

  const formatTimeFromDate = (dateString) => {
    try {
      if (!dateString) return '';
      const fecha = new Date(dateString);
      if (isNaN(fecha.getTime())) return 'Fecha inválida';
      return fecha.toLocaleTimeString('es-ES', {hour: '2-digit', minute: '2-digit'});
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return 'Error';
    }
  };

  // Función para agrupar muestras por orden y tipo de muestra
  const agruparMuestras = (muestrasData) => {
    const grupos = {};
    
    muestrasData.forEach(muestra => {
      const clave = `${muestra.numeroOrden}-${muestra.muestra}-${muestra.modulo}`;
      
      if (!grupos[clave]) {
        grupos[clave] = {
          ...muestra,
          analisis: [muestra.analisis || muestra.muestra],
          cantidadAnalisis: 1,
          ids: [muestra.id]
        };
      } else {
        // Agregar análisis si no existe
        if (!grupos[clave].analisis.includes(muestra.analisis || muestra.muestra)) {
          grupos[clave].analisis.push(muestra.analisis || muestra.muestra);
        }
        grupos[clave].cantidadAnalisis += 1;
        grupos[clave].ids.push(muestra.id);
        
        // Mantener el estado más avanzado
        if (muestra.idEstado > grupos[clave].idEstado) {
          grupos[clave].idEstado = muestra.idEstado;
          grupos[clave].usuario = muestra.usuario;
          grupos[clave].inicioToma = muestra.inicioToma;
          grupos[clave].finToma = muestra.finToma;
        }
      }
    });
    
    return Object.values(grupos);
  };

  const fetchMuestras = async () => {
    setLoading(true);
    try {
      // Validar fechas antes de usar
      if (!fechaInicio || !fechaFin || isNaN(fechaInicio.getTime()) || isNaN(fechaFin.getTime())) {
        console.error('Fechas inválidas:', { fechaInicio, fechaFin });
        return;
      }

      // Obtener muestras verificadas del día actual
      const fechaInicioStr = fechaInicio.toISOString().slice(0, 19).replace('T', ' ');
      const fechaFinStr = fechaFin.toISOString().slice(0, 19).replace('T', ' ');
      
      let url = `${server}/DashboardKanban/kanban?fechaInicio=${fechaInicioStr}&fechaFin=${fechaFinStr}`;
      
      // Agregar búsqueda si existe
      if (busqueda.trim()) {
        url += `&busqueda=${encodeURIComponent(busqueda)}`;
      }
      
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        const muestrasData = data.$values || data;
        
        // Agrupar muestras por orden y tipo de muestra
        const muestrasAgrupadas = agruparMuestras(muestrasData);
        
        // Procesar muestras con histórico de estados
        const muestrasConHistorico = await Promise.all(
          muestrasAgrupadas.map(async (muestra) => {
            // Para muestras agrupadas, usar el primer ID para obtener histórico
            const historico = await fetchHistoricoMuestra(muestra.ids[0]);
            return {
              ...muestra,
              historico,
              tiempoEnEstado: calcularTiempoEnEstado(historico, muestra.idEstado)
            };
          })
        );
        
        setMuestras(muestrasConHistorico);
      }
    } catch (error) {
      console.error('Error al obtener muestras:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchHistoricoMuestra = async (muestraId) => {
    try {
      const response = await fetch(`${server}/mg_historico_estados_muestra/bymuestra/${muestraId}`, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        return data.$values || data;
      }
      return [];
    } catch (error) {
      console.error('Error al obtener histórico:', error);
      return [];
    }
  };

  const calcularTiempoEnEstado = (historico, estadoActual) => {
    try {
      if (!historico || historico.length === 0) return 0;
      
      // Ordenar histórico por fecha con validación
      const historicoOrdenado = [...historico]
        .filter(h => h.fechaCambio) // Filtrar elementos sin fecha
        .sort((a, b) => {
          const fechaA = new Date(a.fechaCambio);
          const fechaB = new Date(b.fechaCambio);
          
          // Validar fechas antes de comparar
          if (isNaN(fechaA.getTime()) || isNaN(fechaB.getTime())) {
            return 0;
          }
          
          return fechaA - fechaB;
        });
      
      // Encontrar el cambio al estado actual
      const cambioActual = historicoOrdenado.find(h => h.estadoNuevo === estadoActual);
      if (!cambioActual) return 0;
      
      const fechaCambio = new Date(cambioActual.fechaCambio);
      const ahora = new Date();
      
      // Validar fechas antes de calcular diferencia
      if (isNaN(fechaCambio.getTime()) || isNaN(ahora.getTime())) {
        return 0;
      }
      
      return Math.floor((ahora - fechaCambio) / (1000 * 60)); // Diferencia en minutos
    } catch (error) {
      console.error('Error al calcular tiempo en estado:', error);
      return 0;
    }
  };

  const getEstadoColor = (estadoId) => {
    const colores = {
      1: '#6c757d', // Pendiente - gris
      2: '#007bff', // Inicio Toma Muestra - azul
      3: '#28a745', // Toma Realizada - verde
      4: '#fd7e14', // Trasladado - naranja
      5: '#20c997', // Verificada - teal
      6: '#dc3545', // Procesada - rojo
      7: '#6610f2', // Anulada - morado
      8: '#ffc107'  // Paciente Ausente - amarillo
    };
    return colores[estadoId] || '#6c757d';
  };

  const getEstadoNombre = (estadoId) => {
    const estado = estadosDisponibles.find(e => e.id === estadoId);
    return estado ? estado.estado : 'Desconocido';
  };

  const formatearTiempo = (minutos) => {
    if (minutos < 60) {
      return `${minutos}m`;
    }
    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;
    return `${horas}h ${minutosRestantes}m`;
  };

  const handleConfiguracionClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleConfiguracionClose = () => {
    setAnchorEl(null);
  };

  const handleCambiarEstado = async (muestra, nuevoEstado) => {
    try {
      // Si es una muestra agrupada, cambiar estado a todas las muestras del grupo
      const ids = muestra.ids || [muestra.id];
      
      const promises = ids.map(muestraId => 
        fetch(`${server}/DashboardKanban/kanban/estado/${muestraId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
          },
          body: JSON.stringify({
            nuevoEstado: nuevoEstado,
            usuarioId: 'SISTEMA', // Aquí deberías usar el usuario actual
            comentario: `Cambio desde Kanban - Grupo de ${ids.length} análisis`
          })
        })
      );

      const responses = await Promise.all(promises);
      
      if (responses.every(response => response.ok)) {
        // Actualizar la lista de muestras
        await fetchMuestras();
        console.log(`Estado cambiado exitosamente para ${ids.length} análisis`);
      } else {
        console.error('Error al cambiar estado en algunas muestras');
      }
    } catch (error) {
      console.error('Error al cambiar estado:', error);
    }
  };

  // Función para manejar el drag and drop (simulado con clicks por ahora)
  const handleMoverMuestra = async (muestra, nuevoEstado) => {
    if (muestra.idEstado === nuevoEstado) return;
    
    await handleCambiarEstado(muestra, nuevoEstado);
  };

  const toggleColumna = (estadoId) => {
    setColumnasVisibles(prev => {
      let nuevasColumnas;
      if (prev.includes(estadoId)) {
        nuevasColumnas = prev.filter(id => id !== estadoId);
      } else {
        nuevasColumnas = [...prev, estadoId];
      }
      
      // Guardar en localStorage
      saveColumnasVisibleToStorage(nuevasColumnas);
      
      return nuevasColumnas;
    });
  };

// Funciones para el modal de TomaMuestra
const handleAbrirTomaMuestra = async (muestra) => {
  try {
    console.log('🔍 Datos de muestra recibidos:', muestra);
    
    // Primero obtenemos los datos completos de la orden médica usando el numeroOrden
    const ordenResponse = await fetch(`${server}/MgOrdenesMedicas/OrdenMedica/${muestra.numeroOrden}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': key,
      }
    });

    if (!ordenResponse.ok) {
      console.error('❌ Error al obtener orden médica - Status:', ordenResponse.status);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo obtener la información de la orden médica'
      });
      return;
    }

    const ordenData = await ordenResponse.json();
    const ordenCompleta = ordenData.$values ? ordenData.$values[0] : ordenData[0] || ordenData;
    
    console.log('📋 Orden médica obtenida:', ordenCompleta);

    // Crear el objeto orden para TomaMuestra con EXACTAMENTE la estructura que espera
    const ordenParaTomaMuestra = {
      // CRÍTICO: Estas son las propiedades que TomaMuestra utiliza
      idOrdenMedica: ordenCompleta.idOrdenMedica,
      idOrdenMedicaMes: muestra.numeroOrden, // Esta es la que usa para buscar
      numeroOrden: muestra.numeroOrden,
      
      // Datos del paciente
      paciente: muestra.paciente || ordenCompleta.nombreCompleto,
      cliente: ordenCompleta.nombreCompleto,
      numeroIdentidad: muestra.numeroIdentidad || ordenCompleta.numeroIdentidad,
      identidad: ordenCompleta.numeroIdentidad,
      
      // Datos adicionales
      sucursalAbreviatura: muestra.sucursalAbreviatura,
      modulo: muestra.modulo,
      fechaIngreso: muestra.fechaIngreso || ordenCompleta.fechaIngreso,
      fechaNacimiento: ordenCompleta.fechaNacimiento,
      telefono: ordenCompleta.telefono,
      sexo: ordenCompleta.descripcionSexo,
      direccion: ordenCompleta.direccionCompleta,
      correoElectronico: ordenCompleta.correoElectronico,
      idSucursal: ordenCompleta.idSucursal,
      
      // Fechas
      fechaRecepcion: ordenCompleta.fechaRecepcion,
      fechaEntrega: ordenCompleta.fechaEntrega,
      sucursalEntrega: ordenCompleta.sucursalEntrega
    };

    // Obtener los detalles de la orden
    const detallesResponse = await fetch(`${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${ordenCompleta.idOrdenMedica}`, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': key,
      }
    });

    if (!detallesResponse.ok) {
      console.error('❌ Error al obtener detalles - Status:', detallesResponse.status);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron obtener los detalles de la orden'
      });
      return;
    }

    const detallesData = await detallesResponse.json();
    const detalles = detallesData.$values || detallesData;
    console.log('📊 Detalles obtenidos:', detalles);
    
    // Verificar que tengamos datos válidos
    if (!detalles || detalles.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Sin detalles',
        text: 'No se encontraron análisis para esta orden'
      });
      return;
    }
    
    console.log('🎯 Configurando TomaMuestra con:');
    console.log('  - idOrdenMedica:', ordenParaTomaMuestra.idOrdenMedica);
    console.log('  - idOrdenMedicaMes:', ordenParaTomaMuestra.idOrdenMedicaMes);
    console.log('  - numeroOrden:', ordenParaTomaMuestra.numeroOrden);
    console.log('  - Detalles count:', detalles.length);
    
    setSelectedOrdenTrabajo(ordenParaTomaMuestra);
    setSelectedDetalles(detalles);
    setOpenTomaMuestra(true);
    
    console.log('✅ Modal TomaMuestra abierto correctamente');
    
  } catch (error) {
    console.error('❌ Error al abrir TomaMuestra:', error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Ocurrió un error al abrir la ventana de toma de muestra'
    });
  }
};

  const handleCerrarTomaMuestra = () => {
    setOpenTomaMuestra(false);
    setSelectedOrdenTrabajo(null);
    setSelectedDetalles([]);
    // Recargar datos después de cerrar el modal
    fetchMuestras();
  };

  // Funciones para el modal de detalle por estado
  const handleAbrirDetalleEstado = async (estadoId) => {
    const estado = estadosDisponibles.find(e => e.id === estadoId);
    const muestrasEstado = muestras.filter(m => m.idEstado === estadoId);
    
    setEstadoSeleccionadoDetalle(estado);
    setMuestrasDetalleEstado(muestrasEstado);
    setModalDetalleEstadoOpen(true);
    
    // Obtener datos completos para la tabla detallada
    await fetchDatosCompletosEstado(estadoId);
  };

  const handleCerrarDetalleEstado = () => {
    setModalDetalleEstadoOpen(false);
    setEstadoSeleccionadoDetalle(null);
    setMuestrasDetalleEstado([]);
    setMuestrasDetalleCompletas([]);
    setFiltros({
      modulo: '',
      colaborador: '',
      responsableSeguimiento: '',
      tipoMuestra: '',
      criterioIncumple: '',
      paciente: '',
      orden: ''
    });
  };

  // Función para obtener datos completos de las muestras con historial - OPTIMIZADA
  const fetchDatosCompletosEstado = async (estadoId) => {
    setCargandoDatosCompletos(true);
    try {
      console.log('🚀 Usando endpoint optimizado para estado:', estadoId);
      
      // Formatear fechas para el endpoint
      const fechaInicioStr = fechaInicio.toISOString();
      const fechaFinStr = fechaFin.toISOString();
      
      // UNA SOLA PETICIÓN al nuevo endpoint optimizado
      const response = await fetch(
        `${server}/DashboardKanban/kanban/detalle-estado/${estadoId}?fechaInicio=${fechaInicioStr}&fechaFin=${fechaFinStr}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error en la petición: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Datos completos recibidos del endpoint optimizado:', data);

      // Extraer el array real de $values si existe (problema de serialización del backend)
      const muestrasCompletas = data.muestras?.$values || data.muestras || [];
      
      // Procesar cada muestra para extraer sus $values anidados
      const muestrasFormateadas = muestrasCompletas.map(m => ({
        ...m,
        analisis: m.analisis?.$values || m.analisis || [],
        historicoCompleto: m.historicoCompleto?.$values || m.historicoCompleto || [],
        historial: m.historial?.$values || m.historial || []
      }));
      
      setMuestrasDetalleCompletas(muestrasFormateadas);
      
      // Extraer datos únicos para filtros
      const modulosUnicos = [...new Set(muestrasFormateadas.map(m => m.modulo).filter(Boolean))];
      const colaboradoresUnicos = [...new Set(muestrasFormateadas.map(m => m.colaboradorReporte).filter(Boolean))];
      const tiposUnicos = [...new Set(muestrasFormateadas.map(m => m.tipoMuestra).filter(Boolean))];
      
      setModulos(modulosUnicos);
      setColaboradores(colaboradoresUnicos);
      setTiposMuestra(tiposUnicos);

      console.log('📊 Muestras procesadas:', muestrasFormateadas.length);
      console.log('🎯 Rendimiento: 1 petición vs', muestrasFormateadas.length * 2, 'peticiones anteriores');

    } catch (error) {
      console.error('❌ Error obteniendo datos completos:', error);
      setMuestrasDetalleCompletas([]);
    } finally {
      setCargandoDatosCompletos(false);
    }
  };

  // Función para exportar a Excel
  const exportarAExcel = () => {
    const muestrasFiltradas = aplicarFiltros();
    
    const datosExcel = muestrasFiltradas.map((muestra, index) => {
      const fila = {};
      
      // Agregar solo las columnas seleccionadas
      if (columnasSeleccionadas.includes('numero')) fila['#'] = index + 1;
      if (columnasSeleccionadas.includes('idMuestra')) fila['ID Muestra'] = muestra.id;
      if (columnasSeleccionadas.includes('orden')) fila['Orden Trabajo'] = muestra.idOrdenTrabajo;
      if (columnasSeleccionadas.includes('paciente')) fila['Paciente'] = muestra.nombrePaciente || 'N/A';
      if (columnasSeleccionadas.includes('telefono')) fila['Teléfono'] = muestra.numeroContacto || 'N/A';
      if (columnasSeleccionadas.includes('tipoMuestra')) fila['Tipo Muestra'] = muestra.tipoMuestra || 'N/A';
      if (columnasSeleccionadas.includes('modulo')) fila['Módulo'] = muestra.modulo || 'N/A';
      if (columnasSeleccionadas.includes('cantidadAnalisis')) fila['Cantidad Análisis'] = muestra.cantidadAnalisis || 1;
      if (columnasSeleccionadas.includes('detalleAnalisis')) fila['Detalle Análisis'] = muestra.analisisDetalle || 'N/A';
      if (columnasSeleccionadas.includes('estadoAnterior')) fila['Estado Anterior'] = muestra.accionAnterior?.estado || 'N/A';
      if (columnasSeleccionadas.includes('estadoActual')) fila['Estado Actual'] = muestra.accionActual?.estado || estadoSeleccionadoDetalle?.estado || 'N/A';
      if (columnasSeleccionadas.includes('estadoSiguiente')) fila['Estado Siguiente'] = muestra.accionSiguiente?.estado || 'N/A';
      if (columnasSeleccionadas.includes('colaborador')) fila['Colaborador Reporte'] = muestra.colaboradorReporte || 'N/A';
      if (columnasSeleccionadas.includes('responsable')) fila['Responsable Seguimiento'] = muestra.accionSiguiente?.responsableSeguimiento || 'N/A';
      if (columnasSeleccionadas.includes('fechaAnterior')) fila['Fecha Anterior'] = muestra.accionAnterior ? new Date(muestra.accionAnterior.fecha).toLocaleString('es-ES') : 'N/A';
      if (columnasSeleccionadas.includes('fechaActual')) fila['Fecha Actual'] = muestra.accionActual ? new Date(muestra.accionActual.fecha).toLocaleString('es-ES') : 'N/A';
      if (columnasSeleccionadas.includes('fechaSiguiente')) fila['Fecha Siguiente'] = muestra.accionSiguiente ? new Date(muestra.accionSiguiente.fecha).toLocaleString('es-ES') : 'N/A';
      if (columnasSeleccionadas.includes('tiempo')) fila['Tiempo en Estado (min)'] = muestra.tiempoEnMinutos || 0;
      if (columnasSeleccionadas.includes('criterioIncumple')) fila['Criterio Incumple Actual'] = muestra.accionActual?.criterioIncumple || muestra.accionActual?.criterio_incumple || muestra.criterioIncumple || 'N/A';
      if (columnasSeleccionadas.includes('comentarios')) fila['Comentario Actual'] = muestra.accionActual?.comentario || 'N/A';
      if (columnasSeleccionadas.includes('fechaIngreso')) fila['Fecha Ingreso'] = new Date(muestra.fechaIngreso).toLocaleString('es-ES');
      
      return fila;
    });

    const worksheet = XLSX.utils.json_to_sheet(datosExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, `${estadoSeleccionadoDetalle?.estado || 'Muestras'}`);
    
    const fileName = `Detalle_${estadoSeleccionadoDetalle?.estado?.replace(/\s+/g, '_') || 'Muestras'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  // Función para aplicar filtros
  const aplicarFiltros = () => {
    return muestrasDetalleCompletas.filter(muestra => {
      return (
        (!filtros.modulo || muestra.modulo?.toLowerCase().includes(filtros.modulo.toLowerCase())) &&
        (!filtros.colaborador || muestra.colaboradorReporte?.toLowerCase().includes(filtros.colaborador.toLowerCase())) &&
        (!filtros.responsableSeguimiento || muestra.accionSiguiente?.responsableSeguimiento?.toLowerCase().includes(filtros.responsableSeguimiento.toLowerCase())) &&
        (!filtros.tipoMuestra || muestra.tipoMuestra?.toLowerCase().includes(filtros.tipoMuestra.toLowerCase())) &&
        (!filtros.criterioIncumple || muestra.criterioIncumple?.toLowerCase().includes(filtros.criterioIncumple.toLowerCase())) &&
        (!filtros.paciente || muestra.nombrePaciente?.toLowerCase().includes(filtros.paciente.toLowerCase())) &&
        (!filtros.orden || muestra.idOrdenTrabajo?.toString().includes(filtros.orden)) &&
        (!filtros.cubiculo || muestra.cubiculo?.toLowerCase().includes(filtros.cubiculo.toLowerCase())) &&
        (!filtros.sucursal || muestra.sucursal?.toLowerCase().includes(filtros.sucursal.toLowerCase()))
      );
    });
  };

  // Función para abrir modal de historial de muestra individual - usando la misma lógica que TomaMuestra
  const handleAbrirHistorialMuestra = async (muestra) => {
    try {
      console.log('🔍 📋 Muestra seleccionada para historial:', muestra);
      
      setDatosMuestraHistorial(muestra);
      
      // Usar exactamente la misma lógica que TomaMuestra
      let historicoFinal = [];
      
      // Opción 1: usar historicoCompleto si existe (objeto agrupado)
      if (muestra.historicoCompleto && muestra.historicoCompleto.length > 0) {
        historicoFinal = muestra.historicoCompleto;
        console.log('🔍 📋 Usando historicoCompleto:', historicoFinal.length, 'registros');
      }
      // Opción 2: usar histórico directo del objeto individual
      else if (muestra.historial) {
        // Manejar diferentes estructuras
        if (muestra.historial.$values && Array.isArray(muestra.historial.$values)) {
          historicoFinal = muestra.historial.$values;
          console.log('🔍 📋 Usando muestra.historial.$values:', historicoFinal.length, 'registros');
        } else if (Array.isArray(muestra.historial)) {
          historicoFinal = muestra.historial;
          console.log('🔍 📋 Usando muestra.historial array:', historicoFinal.length, 'registros');
        }
        
        // Ordenar por fecha (más reciente primero para el modal, pero mostrar cronológicamente)
        if (historicoFinal.length > 0) {
          historicoFinal = historicoFinal.sort((a, b) => {
            const fechaA = new Date(a.fecha_cambio_estado || 0);
            const fechaB = new Date(b.fecha_cambio_estado || 0);
            return fechaA - fechaB; // Orden cronológico para el historial
          });
        }
      }
      // Opción 3: extraer de cada examen individual (objeto agrupado con examenes)
      else if (muestra.examenes && muestra.examenes.length > 0) {
        console.log('🔍 📋 Procesando examenes individuales:', muestra.examenes.length);
        muestra.examenes.forEach((examen) => {
          if (examen.historico) {
            // Manejar diferentes estructuras
            let historicoExamen = [];
            
            if (examen.historico.$values && Array.isArray(examen.historico.$values)) {
              historicoExamen = examen.historico.$values;
            } else if (Array.isArray(examen.historico)) {
              historicoExamen = examen.historico;
            }
            
            if (historicoExamen.length > 0) {
              historicoFinal.push(...historicoExamen);
            }
          }
        });
        
        // Ordenar por fecha (cronológico)
        historicoFinal = historicoFinal.sort((a, b) => {
          const fechaA = new Date(a.fecha_cambio_estado || 0);
          const fechaB = new Date(b.fecha_cambio_estado || 0);
          return fechaA - fechaB;
        });
        
        console.log('🔍 📋 Historial combinado de examenes:', historicoFinal.length, 'registros');
      }
      
      // Si no se encontró historial en los datos, intentar obtenerlo de la API
      if (historicoFinal.length === 0) {
        console.log('🔍 📋 No hay historial en los datos, obteniendo desde API...');
        const idMuestraParaHistorial = muestra.ids && muestra.ids.length > 0 ? muestra.ids[0] : muestra.id;
        setModalHistorialMuestraOpen(true);
        await fetchHistorialCompletaMuestra(idMuestraParaHistorial);
        return;
      }
      
      console.log('🔍 📋 HISTORIAL FINAL para mostrar:', historicoFinal.length, 'registros');
      historicoFinal.forEach((registro, index) => {
        console.log(`🔍 📋 Registro ${index + 1}:`, {
          fecha: registro.fecha_cambio_estado,
          estadoAnterior: registro.id_estado_anteriorNavigation?.estado || registro.estadoAnterior,
          estadoNuevo: registro.id_estado_nuevoNavigation?.estado || registro.estadoNuevo,
          usuario: registro.cambiado_por || registro.ingresadoPor,
          criterioIncumple: registro.criterioIncumple || registro.criterio_incumple,
          comentario: registro.comentario
        });
      });
      
      setHistorialMuestraSeleccionada(historicoFinal);
      setModalHistorialMuestraOpen(true);
      
    } catch (error) {
      console.error('Error al abrir historial de muestra:', error);
      setHistorialMuestraSeleccionada([]);
      setModalHistorialMuestraOpen(true);
    }
  };

  // Función para obtener historial completo usando la misma API que TomaMuestra
  const fetchHistorialCompletaMuestra = async (idMuestraOrden) => {
    try {
      console.log('🔍 📋 Obteniendo TODOS los registros del historial para muestra ID:', idMuestraOrden);
      
      // Usar exactamente la misma API que usa TomaMuestra
      const url = `${server}/mg_historico_estados_muestra/pormuestraxorden/${idMuestraOrden}`;
      console.log('🔍 📋 URL:', url);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': key,
        },
      });

      console.log('🔍 📋 Response status:', response.status);

      if (response.ok) {
        const data = await response.json();
        console.log('🔍 📋 DATOS COMPLETOS recibidos:', data);
        
        let historico = [];
        
        // Extraer datos de la misma manera que en TomaMuestra
        if (data.values && data.values.$values) {
          historico = data.values.$values;
          console.log('🔍 📋 Extraído de data.values.$values');
        } else if (data.Values && data.Values.$values) {
          historico = data.Values.$values;
          console.log('🔍 📋 Extraído de data.Values.$values');
        } else if (data.$values) {
          historico = data.$values;
          console.log('🔍 📋 Extraído de data.$values');
        } else if (data.values) {
          historico = data.values;
          console.log('🔍 📋 Extraído de data.values');
        } else if (data.Values) {
          historico = data.Values;
          console.log('🔍 📋 Extraído de data.Values');
        } else if (Array.isArray(data)) {
          historico = data;
          console.log('🔍 📋 Data es array directo');
        }

        console.log('🔍 📋 HISTÓRICO COMPLETO extraído:', historico);
        console.log('🔍 📋 Total de registros:', historico?.length || 0);

        if (Array.isArray(historico) && historico.length > 0) {
          // Ordenar cronológicamente (más antiguo primero para mostrar la evolución)
          const historicoOrdenado = historico.sort((a, b) => {
            const fechaA = new Date(a.fecha_cambio_estado || '1900-01-01');
            const fechaB = new Date(b.fecha_cambio_estado || '1900-01-01');
            return fechaA - fechaB;
          });
          
          console.log('🔍 📋 HISTORIAL ORDENADO FINAL:', historicoOrdenado);
          console.log('🔍 📋 Total registros a mostrar:', historicoOrdenado.length);
          
          // Log cada registro para debug
          historicoOrdenado.forEach((registro, index) => {
            console.log(`🔍 📋 Registro ${index + 1}:`, {
              fecha: registro.fecha_cambio_estado,
              estadoAnterior: registro.id_estado_anteriorNavigation?.estado,
              estadoNuevo: registro.id_estado_nuevoNavigation?.estado,
              usuario: registro.cambiado_por,
              comentario: registro.comentario
            });
          });
          
          setHistorialMuestraSeleccionada(historicoOrdenado);
        } else {
          console.warn('🔍 📋 No se encontraron registros de historial');
          setHistorialMuestraSeleccionada([]);
        }
      } else {
        console.error('🔍 📋 Error en response:', response.status, response.statusText);
        const errorText = await response.text();
        console.error('🔍 📋 Error details:', errorText);
        setHistorialMuestraSeleccionada([]);
      }
    } catch (error) {
      console.error('🔍 📋 Error obteniendo historial completo:', error);
      setHistorialMuestraSeleccionada([]);
    }
  };

  // Función para cerrar modal de historial de muestra
  const handleCerrarHistorialMuestra = () => {
    setModalHistorialMuestraOpen(false);
    setHistorialMuestraSeleccionada([]);
    setDatosMuestraHistorial(null);
  };

  // Funciones para manejo de columnas seleccionadas
  const handleToggleColumna = (columnaId) => {
    setColumnasSeleccionadas(prev => {
      let nuevasColumnas;
      if (prev.includes(columnaId)) {
        // No permitir desmarcar si es la última columna
        if (prev.length === 1) {
          return prev;
        }
        nuevasColumnas = prev.filter(id => id !== columnaId);
        
        // Limpiar el filtro correspondiente cuando se deselecciona la columna
        setFiltros(prevFiltros => {
          const nuevosFiltros = { ...prevFiltros };
          
          // Mapeo de columnas a sus filtros
          const mapaColumnaFiltro = {
            'modulo': 'modulo',
            'colaborador': 'colaborador',
            'responsable': 'responsableSeguimiento',
            'tipoMuestra': 'tipoMuestra',
            'criterioIncumple': 'criterioIncumple',
            'paciente': 'paciente',
            'orden': 'orden'
          };
          
          // Si la columna tiene un filtro asociado, limpiarlo
          if (mapaColumnaFiltro[columnaId]) {
            nuevosFiltros[mapaColumnaFiltro[columnaId]] = '';
          }
          
          return nuevosFiltros;
        });
        
      } else {
        nuevasColumnas = [...prev, columnaId];
      }
      
      // Guardar en localStorage
      try {
        localStorage.setItem('kanban-columnas-tabla-detalle', JSON.stringify(nuevasColumnas));
      } catch (error) {
        console.error('Error al guardar columnas seleccionadas:', error);
      }
      
      return nuevasColumnas;
    });
  };

  const handleSeleccionarTodasColumnas = () => {
    const todasColumnas = columnasDisponibles.map(col => col.id);
    setColumnasSeleccionadas(todasColumnas);
    try {
      localStorage.setItem('kanban-columnas-tabla-detalle', JSON.stringify(todasColumnas));
    } catch (error) {
      console.error('Error al guardar columnas:', error);
    }
  };

  const handleRestablecerColumnas = () => {
    const columnasDefault = columnasDisponibles.filter(col => col.enabled).map(col => col.id);
    setColumnasSeleccionadas(columnasDefault);
    try {
      localStorage.setItem('kanban-columnas-tabla-detalle', JSON.stringify(columnasDefault));
    } catch (error) {
      console.error('Error al guardar columnas:', error);
    }
  };

  const handleAbrirMenuColumnas = (event) => {
    setAnchorElColumnas(event.currentTarget);
  };

  const handleCerrarMenuColumnas = () => {
    setAnchorElColumnas(null);
  };

  // Función helper para verificar si una columna está seleccionada
  const isColumnaSeleccionada = (columnaId) => {
    return columnasSeleccionadas.includes(columnaId);
  };

  const MuestraCard = ({ muestra }) => {
    return (
      <div 
        className="well well-sm"
        style={{ 
          marginBottom: '12px',
          cursor: 'pointer',
          transition: 'all 0.2s',
          borderLeft: `4px solid ${getEstadoColor(muestra.idEstado)}`,
          backgroundColor: '#f9f9f9',
          padding: '12px'
        }}
        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
        onMouseLeave={(e) => e.target.style.transform = 'translateY(0px)'}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: '#333', lineHeight: '1.2' }}>
            {muestra.sucursalAbreviatura}{muestra.numeroOrden}
          </strong>
          <button 
            className="btn btn-xs btn-success"
            onClick={(e) => {
              e.stopPropagation();
              handleAbrirTomaMuestra(muestra);
            }}
            style={{ 
              padding: '4px 8px', 
              fontSize: '11px',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: '3px'
            }}
            title="Abrir Toma de Muestra"
          >
            <i className="fa fa-flask" style={{ marginRight: '4px' }}></i>
            Toma
          </button>
        </div>
        
        <div style={{ fontSize: '13px', color: '#333', marginBottom: '6px', fontWeight: '500' }}>
          {muestra.paciente}
        </div>
        
        <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
          <i className="fa fa-hospital-o" style={{ marginRight: '4px' }}></i>
          {muestra.modulo}
        </div>
        
        <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
          <strong>Muestra:</strong> {muestra.muestra}
          {muestra.cantidadAnalisis > 1 && (
            <span className="label label-warning" style={{ marginLeft: '8px', fontSize: '10px' }}>
              {muestra.cantidadAnalisis} análisis
            </span>
          )}
        </div>
        
        {/* Mostrar análisis agrupados */}
        {muestra.analisis && muestra.analisis.length > 1 && (
          <div style={{ fontSize: '11px', color: '#666', marginBottom: '5px', backgroundColor: '#f0f0f0', padding: '4px', borderRadius: '3px' }}>
            <strong>Análisis:</strong>
            <div style={{ marginTop: '2px' }}>
              {muestra.analisis.slice(0, 3).map((analisis, index) => (
                <span key={index} className="label label-default" style={{ marginRight: '4px', marginBottom: '2px', fontSize: '9px', display: 'inline-block' }}>
                  {analisis}
                </span>
              ))}
              {muestra.analisis.length > 3 && (
                <span className="label label-info" style={{ fontSize: '9px' }}>
                  +{muestra.analisis.length - 3} más
                </span>
              )}
            </div>
          </div>
        )}
        
        <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
          <strong>ID:</strong> {muestra.numeroIdentidad}
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1px solid #eee', paddingTop: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className="btn btn-xs btn-round btn-primary" style={{ marginRight: '8px', fontSize: '11px', minWidth: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {muestra.usuario ? muestra.usuario.charAt(0) : 'U'}
            </span>
            <span style={{ fontSize: '11px', color: '#666' }}>
              {muestra.usuario || 'Sistema'}
            </span>
          </div>
          
          <span className="label label-info" style={{ fontSize: '10px', padding: '4px 8px' }}>
            <i className="fa fa-clock-o"></i> {formatearTiempo(muestra.tiempoMinutos || 0)}
          </span>
        </div>
        
        {/* Información de fechas */}
        {muestra.inicioToma && (
          <div style={{ fontSize: '11px', color: '#999', marginTop: '8px', borderTop: '1px solid #f0f0f0', paddingTop: '6px' }}>
            <strong>Inicio:</strong> {formatTimeFromDate(muestra.inicioToma)}
            {muestra.finToma && (
              <> | <strong>Fin:</strong> {formatTimeFromDate(muestra.finToma)}</>
            )}
          </div>
        )}
      </div>
    );
  };

  const ColumnaEstado = ({ estadoId }) => {
    const muestrasColumna = muestras.filter(m => m.idEstado === estadoId);
    const nombreEstado = getEstadoNombre(estadoId);
    const colorEstado = getEstadoColor(estadoId);

    return (
      <div className="x_panel" style={{ minHeight: '600px', marginBottom: '20px' }}>
        <div className="x_title" style={{ borderBottom: `3px solid ${colorEstado}`, padding: '15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 style={{ color: colorEstado, fontSize: '18px', margin: '0' }}>
              {nombreEstado}
              <span className="badge" style={{ 
                backgroundColor: colorEstado, 
                marginLeft: '10px',
                color: 'white',
                fontSize: '12px',
                padding: '6px 10px'
              }}>
                {muestrasColumna.length}
              </span>
            </h2>
            <button 
              className="btn btn-primary btn-xs"
              onClick={() => handleAbrirDetalleEstado(estadoId)}
              style={{ 
                fontSize: '11px',
                padding: '4px 8px',
                backgroundColor: colorEstado,
                borderColor: colorEstado
              }}
              title={`Ver histórico de muestras en ${nombreEstado}`}
            >
              <i className="fa fa-list"></i> Ver Historico
            </button>
          </div>
          <div className="clearfix"></div>
        </div>
        
        <div className="x_content" style={{ maxHeight: '500px', overflowY: 'auto', padding: '10px' }}>
          {muestrasColumna.map((muestra) => (
            <MuestraCard key={muestra.id} muestra={muestra} />
          ))}
          
          {muestrasColumna.length === 0 && (
            <div className="text-center" style={{ marginTop: '50px', color: '#999' }}>
              <i className="fa fa-inbox fa-3x"></i>
              <p style={{ fontSize: '14px', marginTop: '15px' }}>No hay muestras en este estado</p>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="right_col" role="main">
      <div className="">
        <div className="page-title">
          <div className="title_left">
            <h3>
              Kanban - Estados de Toma de Muestra
              {loading && (
                <span style={{ marginLeft: '10px', color: '#1ABB9C', fontSize: '14px' }}>
                  <i className="fa fa-spinner fa-spin"></i> Actualizando datos...
                </span>
              )}
              {autoActualizar && !loading && (
                <span style={{ marginLeft: '10px', color: '#5bc0de', fontSize: '12px' }}>
                  <i className="fa fa-clock-o"></i> Próxima actualización: {tiempoRestante}s
                </span>
              )}
            </h3>
          </div>
          <div className="title_right">
            <div className="col-md-5 col-sm-5 form-group pull-right top_search">
              <div className="input-group">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Buscar muestras..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                />
                <span className="input-group-btn">
                  <button 
                    className="btn btn-default" 
                    type="button"
                    onClick={fetchMuestras}
                    disabled={loading}
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="clearfix"></div>

        {/* Filtros */}
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <div className="x_panel">
              <div className="x_title">
                <h2>Filtros de Búsqueda</h2>
                <ul className="nav navbar-right panel_toolbox">
                  <li>
                    <button 
                      className="btn btn-success btn-sm"
                      onClick={actualizarTodo}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <i className="fa fa-spinner fa-spin"></i> Actualizando...
                        </>
                      ) : (
                        <>
                          <i className="fa fa-refresh"></i> Actualizar
                        </>
                      )}
                    </button>
                  </li>
                </ul>
                <div className="clearfix"></div>
              </div>
              <div className="x_content">
                <div className="row">
                  <div className="col-md-2 col-sm-3">
                    <label style={{ fontSize: '12px', marginBottom: '2px' }}>Fecha Inicio:</label>
                    <input
                      type="datetime-local"
                      className="form-control input-sm"
                      value={formatDateForInput(fechaInicio)}
                      onChange={handleFechaInicioChange}
                    />
                  </div>
                  <div className="col-md-2 col-sm-3">
                    <label style={{ fontSize: '12px', marginBottom: '2px' }}>Fecha Fin:</label>
                    <input
                      type="datetime-local"
                      className="form-control input-sm"
                      value={formatDateForInput(fechaFin)}
                      onChange={handleFechaFinChange}
                    />
                  </div>
                  <div className="col-md-2 col-sm-2">
                    <label style={{ fontSize: '12px', marginBottom: '2px' }}>Muestras:</label>
                    <div className="form-control-static" style={{ fontSize: '12px', minHeight: '28px', paddingTop: '2px' }}>
                      <strong>{muestras.length}</strong> agrupadas
                      <br /><small style={{ fontSize: '10px', color: '#666' }}>
                        ({muestras.reduce((total, m) => total + (m.cantidadAnalisis || 1), 0)} indiv.)
                      </small>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-2">
                    <label style={{ fontSize: '12px', marginBottom: '2px' }}>Auto-actualización:</label>
                    <div className="form-control-static">
                      <button 
                        className={`btn btn-xs ${autoActualizar ? 'btn-success' : 'btn-default'}`}
                        onClick={toggleAutoActualizar}
                        title={autoActualizar ? `Próxima actualización en ${tiempoRestante}s` : 'Auto-actualización desactivada'}
                        style={{ fontSize: '11px' }}
                      >
                        <i className={`fa ${autoActualizar ? 'fa-play' : 'fa-pause'}`}></i> 
                        {autoActualizar ? 'ON' : 'OFF'}
                        {autoActualizar && (
                          <small style={{ marginLeft: '3px', fontSize: '9px', opacity: 0.8 }}>
                            {tiempoRestante}s
                          </small>
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="col-md-2 col-sm-2">
                    <label style={{ fontSize: '12px', marginBottom: '2px' }}>Intervalo:</label>
                    <select 
                      className="form-control input-sm"
                      value={intervaloSegundos}
                      onChange={(e) => handleCambiarIntervalo(parseInt(e.target.value))}
                      style={{ fontSize: '11px' }}
                    >
                      <option value={5}>5s</option>
                      <option value={10}>10s</option>
                      <option value={15}>15s</option>
                      <option value={30}>30s</option>
                      <option value={60}>1m</option>
                      <option value={120}>2m</option>
                      <option value={300}>5m</option>
                    </select>
                  </div>
                  <div className="col-md-2 col-sm-12">
                    <label style={{ fontSize: '12px', marginBottom: '2px' }}>&nbsp;</label>
                    <div>
                      <button 
                        className={`btn btn-sm ${configGuardada ? 'btn-success' : 'btn-primary'}`}
                        onClick={handleConfiguracionClick}
                        style={{ fontSize: '11px', width: '100%' }}
                      >
                        {configGuardada ? (
                          <>
                            <i className="fa fa-check"></i> Guardado
                          </>
                        ) : (
                          <>
                            <i className="fa fa-cog"></i> Columnas
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Kanban Board */}
        <div className="row" style={{ marginLeft: '0', marginRight: '0' }}>
          {columnasVisibles.map((estadoId) => (
            <div key={estadoId} className="col-md-4 col-sm-6 col-xs-12" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
              <ColumnaEstado estadoId={estadoId} />
            </div>
          ))}
        </div>

        {/* Menu de configuración */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleConfiguracionClose}
        >
          <MenuItem disabled>
            <strong>Columnas Visibles</strong>
            <div style={{ fontSize: '11px', color: '#666', fontWeight: 'normal', marginTop: '2px' }}>
              <i className="fa fa-save" style={{ marginRight: '4px' }}></i>
              Se guarda automáticamente
            </div>
          </MenuItem>
          <Divider />
          {estadosDisponibles.map((estado) => (
            <MenuItem 
              key={estado.id}
              onClick={() => toggleColumna(estado.id)}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%' }}>
                <div
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: getEstadoColor(estado.id)
                  }}
                />
                <span 
                  style={{ 
                    fontWeight: columnasVisibles.includes(estado.id) ? 'bold' : 'normal',
                    color: columnasVisibles.includes(estado.id) ? '#1ABB9C' : '#333'
                  }}
                >
                  {estado.estado}
                </span>
                {columnasVisibles.includes(estado.id) && (
                  <span style={{ color: '#1ABB9C', fontSize: '12px' }}>
                    ✓
                  </span>
                )}
              </div>
            </MenuItem>
          ))}
          <Divider />
          <MenuItem onClick={() => {
            limpiarConfiguracion();
            handleConfiguracionClose();
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', color: '#dc3545' }}>
              <i className="fa fa-refresh" style={{ fontSize: '12px' }}></i>
              <span style={{ fontSize: '13px' }}>
                Restablecer por defecto
              </span>
            </div>
          </MenuItem>
        </Menu>

        {/* Modal de TomaMuestra */}
        <Modal 
          open={openTomaMuestra} 
          onClose={handleCerrarTomaMuestra}
          slotProps={{
            backdrop: {
              style: { zIndex: 1300 }
            }
          }}
          sx={{ zIndex: 1300 }}
        >
          <Box sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '98%', sm: '95%', md: '85%' },
            maxHeight: { xs: '98vh', sm: '95vh' },
            overflowY: 'auto',
            backgroundColor: 'white',
            padding: '2px',
            borderRadius: '4px',
            zIndex: 1301
          }}>
            <TomaMuestra
              selectedOrden={selectedOrdenTrabajo}
              selectedDetalles={selectedDetalles}
              open={openTomaMuestra}
              onClose={handleCerrarTomaMuestra}
            />
          </Box>
        </Modal>

        {/* Modal de Detalle por Estado */}
        <Dialog
          open={modalDetalleEstadoOpen}
          onClose={handleCerrarDetalleEstado}
          maxWidth="xl"
          fullWidth
          PaperProps={{
            style: {
              minHeight: '80vh',
              maxHeight: '90vh',
             
            }
          }}

        
        >
          <DialogTitle sx={{ 
            backgroundColor: estadoSeleccionadoDetalle?.id ? getEstadoColor(estadoSeleccionadoDetalle.id) : '#6c757d',
            color: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span>
                Detalle: {estadoSeleccionadoDetalle?.estado || 'Estado'}
              </span>
              <Chip
                label={`${muestrasDetalleEstado.length} muestra(s)`}
                size="small"
                sx={{ 
                  backgroundColor: 'rgba(255,255,255,0.2)', 
                  color: 'white',
                  fontWeight: 'bold'
                }}
              />
            </div>
            <IconButton 
              onClick={handleCerrarDetalleEstado}
              sx={{ color: 'white' }}
            >
              <i className="fa fa-times"></i>
            </IconButton>
          </DialogTitle>
          
          <DialogContent sx={{ padding: '16px' }}>
            {/* Barra de herramientas con filtros y exportar */}
            <Box sx={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: 2, 
              marginBottom: 2,
              padding: 2,
              backgroundColor: '#f8f9fa',
              borderRadius: 1
            }}>
              {/* Botones de acción */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<i className="fa fa-columns"></i>}
                    onClick={handleAbrirMenuColumnas}
                  >
                    Columnas ({columnasSeleccionadas.length})
                  </Button>
                </Box>
                <Button
                  variant="contained"
                  color="success"
                  startIcon={<i className="fa fa-file-excel-o"></i>}
                  onClick={exportarAExcel}
                  disabled={cargandoDatosCompletos || muestrasDetalleCompletas.length === 0}
                  size="small"
                >
                  Exportar a Excel
                </Button>
              </Box>

              {/* Filtros */}
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                gap: 2 
              }}>
                {isColumnaSeleccionada('orden') && (
                  <TextField
                    label="Orden"
                    size="small"
                    value={filtros.orden}
                    onChange={(e) => setFiltros(prev => ({...prev, orden: e.target.value}))}
                    placeholder="Buscar por orden..."
                  />
                )}
                
                {isColumnaSeleccionada('paciente') && (
                  <TextField
                    label="Paciente"
                    size="small"
                    value={filtros.paciente}
                    onChange={(e) => setFiltros(prev => ({...prev, paciente: e.target.value}))}
                    placeholder="Buscar por paciente..."
                  />
                )}

                {isColumnaSeleccionada('modulo') && (
                  <FormControl size="small">
                    <InputLabel>Módulo</InputLabel>
                    <Select
                      value={filtros.modulo}
                      label="Módulo"
                      onChange={(e) => setFiltros(prev => ({...prev, modulo: e.target.value}))}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {modulos.map(modulo => (
                        <MenuItem key={modulo} value={modulo}>{modulo}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {isColumnaSeleccionada('colaborador') && (
                  <FormControl size="small">
                    <InputLabel>Colaborador</InputLabel>
                    <Select
                      value={filtros.colaborador}
                      label="Colaborador"
                      onChange={(e) => setFiltros(prev => ({...prev, colaborador: e.target.value}))}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {colaboradores.map(colaborador => (
                        <MenuItem key={colaborador} value={colaborador}>{colaborador}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {isColumnaSeleccionada('tipoMuestra') && (
                  <FormControl size="small">
                    <InputLabel>Tipo Muestra</InputLabel>
                    <Select
                      value={filtros.tipoMuestra}
                      label="Tipo Muestra"
                      onChange={(e) => setFiltros(prev => ({...prev, tipoMuestra: e.target.value}))}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {tiposMuestra.map(tipo => (
                        <MenuItem key={tipo} value={tipo}>{tipo}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {isColumnaSeleccionada('responsable') && (
                  <TextField
                    label="Responsable Seguimiento"
                    size="small"
                    value={filtros.responsableSeguimiento}
                    onChange={(e) => setFiltros(prev => ({...prev, responsableSeguimiento: e.target.value}))}
                    placeholder="Buscar responsable..."
                  />
                )}

                {isColumnaSeleccionada('criterioIncumple') && (
                  <TextField
                    label="Criterio Incumple"
                    size="small"
                    value={filtros.criterioIncumple}
                    onChange={(e) => setFiltros(prev => ({...prev, criterioIncumple: e.target.value}))}
                    placeholder="Buscar criterio..."
                  />
                )}

                {isColumnaSeleccionada('cubiculo') && (
                  <FormControl size="small">
                    <InputLabel>Cubículo</InputLabel>
                    <Select
                      value={filtros.cubiculo}
                      label="Cubículo"
                      onChange={(e) => setFiltros(prev => ({...prev, cubiculo: e.target.value}))}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      <MenuItem value="TOMA 1">TOMA 1</MenuItem>
                      <MenuItem value="TOMA 2">TOMA 2</MenuItem>
                      <MenuItem value="TOMA 3">TOMA 3</MenuItem>
                    </Select>
                  </FormControl>
                )}

                {isColumnaSeleccionada('sucursal') && (
                  <TextField
                    label="Sucursal"
                    size="small"
                    value={filtros.sucursal}
                    onChange={(e) => setFiltros(prev => ({...prev, sucursal: e.target.value}))}
                    placeholder="Buscar por sucursal..."
                  />
                )}
              </Box>

              {/* Indicador de resultados */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip
                  label={`${aplicarFiltros().length} de ${muestrasDetalleCompletas.length} muestras`}
                  size="small"
                  color="primary"
                  variant="outlined"
                />
                {cargandoDatosCompletos && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={16} />
                    <Typography variant="caption" color="textSecondary">
                      Cargando datos completos...
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Tabla detallada */}
            <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    {isColumnaSeleccionada('numero') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>#</TableCell>}
                    {isColumnaSeleccionada('idMuestra') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>ID</TableCell>}
                    {isColumnaSeleccionada('orden') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Orden</TableCell>}
                    {isColumnaSeleccionada('paciente') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Paciente</TableCell>}
                    {isColumnaSeleccionada('telefono') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Teléfono</TableCell>}
                    {isColumnaSeleccionada('tipoMuestra') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Tipo Muestra</TableCell>}
                    {isColumnaSeleccionada('modulo') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Módulo</TableCell>}
                    {isColumnaSeleccionada('cantidadAnalisis') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Cant. Análisis</TableCell>}
                    {isColumnaSeleccionada('detalleAnalisis') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Detalle Análisis</TableCell>}
                    {isColumnaSeleccionada('estadoAnterior') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Estado Anterior</TableCell>}
                    {isColumnaSeleccionada('estadoActual') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Estado Actual</TableCell>}
                    {isColumnaSeleccionada('estadoSiguiente') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Estado Siguiente</TableCell>}
                    {isColumnaSeleccionada('colaborador') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Colaborador</TableCell>}
                    {isColumnaSeleccionada('responsable') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Responsable</TableCell>}
                    {isColumnaSeleccionada('cubiculo') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Cubículo</TableCell>}
                    {isColumnaSeleccionada('sucursal') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Sucursal</TableCell>}
                    {isColumnaSeleccionada('fechaAnterior') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Fecha Anterior</TableCell>}
                    {isColumnaSeleccionada('fechaActual') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Fecha Actual</TableCell>}
                    {isColumnaSeleccionada('fechaSiguiente') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Fecha Siguiente</TableCell>}
                    {isColumnaSeleccionada('tiempo') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Tiempo (min)</TableCell>}
                    {isColumnaSeleccionada('criterioIncumple') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Criterio Incumple</TableCell>}
                    {isColumnaSeleccionada('comentarios') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Comentarios</TableCell>}
                    {isColumnaSeleccionada('fechaIngreso') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Fecha Ingreso</TableCell>}
                    {isColumnaSeleccionada('acciones') && <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', fontSize: '11px' }}>Acciones</TableCell>}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {aplicarFiltros().map((muestra, index) => (
                    <TableRow 
                      key={muestra.id}
                      hover
                      sx={{ 
                        '&:hover': { backgroundColor: '#f8f9fa' },
                        '&:nth-of-type(odd)': { backgroundColor: '#fafafa' }
                      }}
                    >
                      {isColumnaSeleccionada('numero') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <strong>{index + 1}</strong>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('idMuestra') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <strong>{muestra.id}</strong>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('orden') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          {muestra.idOrdenTrabajo}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('paciente') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px', maxWidth: '120px' }}>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <strong>{muestra.nombrePaciente || 'N/A'}</strong>
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('telefono') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          {muestra.numeroContacto || 'N/A'}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('tipoMuestra') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <div>
                            <strong>{muestra.tipoMuestra || 'N/A'}</strong>
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('modulo') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <Chip
                            label={muestra.modulo || 'N/A'}
                            size="small"
                            variant="outlined"
                            sx={{ fontSize: '8px', height: '20px' }}
                          />
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('cantidadAnalisis') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px', textAlign: 'center' }}>
                          {muestra.cantidadAnalisis || 1}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('detalleAnalisis') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px', maxWidth: '150px' }}>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {muestra.analisisDetalle || 'N/A'}
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('estadoAnterior') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <Chip
                            label={muestra.accionAnterior?.estado || 'N/A'}
                            size="small"
                            color="secondary"
                            variant="outlined"
                            sx={{ fontSize: '8px', height: '18px' }}
                          />
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('estadoActual') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <Chip
                            label={muestra.accionActual?.estado || estadoSeleccionadoDetalle?.estado || 'N/A'}
                            size="small"
                            color="primary"
                            sx={{ fontSize: '8px', height: '18px' }}
                          />
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('estadoSiguiente') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <Chip
                            label={muestra.accionSiguiente?.estado || 'N/A'}
                            size="small"
                            color="info"
                            variant="outlined"
                            sx={{ fontSize: '8px', height: '18px' }}
                          />
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('colaborador') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <div style={{ maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {muestra.colaboradorReporte || 'N/A'}
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('responsable') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <div style={{ maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {muestra.accionSiguiente?.responsableSeguimiento || 'N/A'}
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('cubiculo') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <Chip
                            label={muestra.cubiculo || 'N/A'}
                            size="small"
                            color="primary"
                            variant="outlined"
                            sx={{ fontSize: '8px', height: '18px' }}
                          />
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('sucursal') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <div style={{ maxWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {muestra.sucursal || 'N/A'}
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('fechaAnterior') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          {muestra.accionAnterior ? new Date(muestra.accionAnterior.fecha).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : 'N/A'}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('fechaActual') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          {muestra.accionActual ? new Date(muestra.accionActual.fecha).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : 'N/A'}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('fechaSiguiente') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          {muestra.accionSiguiente ? new Date(muestra.accionSiguiente.fecha).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : 'N/A'}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('tiempo') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <Chip
                            label={`${muestra.tiempoEnMinutos || 0} min`}
                            size="small"
                            color={muestra.tiempoEnMinutos > 60 ? 'warning' : 'default'}
                            sx={{ fontSize: '8px', height: '18px' }}
                          />
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('criterioIncumple') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px', maxWidth: '100px' }}>
                          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {muestra.accionActual?.criterioIncumple || muestra.accionActual?.criterio_incumple || muestra.criterioIncumple || 'N/A'}
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('comentarios') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px', maxWidth: '150px' }}>
                          <div style={{ 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            cursor: muestra.accionActual?.comentario ? 'pointer' : 'default'
                          }}
                          title={muestra.accionActual?.comentario || 'Sin comentarios'}>
                            {muestra.accionActual?.comentario || 'Sin comentarios'}
                          </div>
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('fechaIngreso') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          {new Date(muestra.fechaIngreso).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' })}
                        </TableCell>
                      )}
                      {isColumnaSeleccionada('acciones') && (
                        <TableCell sx={{ fontSize: '10px', padding: '4px 8px' }}>
                          <div style={{ display: 'flex', gap: '2px' }}>
                            <Tooltip title="Abrir TomaMuestra">
                              <IconButton
                                size="small"
                                onClick={() => {
                                  handleCerrarDetalleEstado();
                                  handleAbrirTomaMuestra(muestra);
                                }}
                                sx={{ fontSize: '10px', padding: '2px' }}
                              >
                                <i className="fa fa-edit"></i>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Ver historial completo">
                              <IconButton
                                size="small"
                                sx={{ fontSize: '10px', padding: '2px' }}
                                onClick={() => handleAbrirHistorialMuestra(muestra)}
                              >
                                <i className="fa fa-history"></i>
                              </IconButton>
                            </Tooltip>
                          </div>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                  
                  {/* Mensaje cuando no hay resultados */}
                  {aplicarFiltros().length === 0 && !cargandoDatosCompletos && (
                    <TableRow>
                      <TableCell colSpan={columnasSeleccionadas.length} sx={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                        {muestrasDetalleCompletas.length === 0 ? 
                          'No hay muestras en este estado' : 
                          'No se encontraron muestras que coincidan con los filtros aplicados'
                        }
                      </TableCell>
                    </TableRow>
                  )}
                  
                  {/* Mensaje de carga */}
                  {cargandoDatosCompletos && (
                    <TableRow>
                      <TableCell colSpan={columnasSeleccionadas.length} sx={{ textAlign: 'center', padding: '20px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                          <CircularProgress size={24} />
                          <Typography variant="body2" color="textSecondary">
                            Cargando datos completos...
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            
            {muestrasDetalleEstado.length === 0 && (
              <div style={{ 
                textAlign: 'center', 
                padding: '50px',
                color: '#999'
              }}>
                <i className="fa fa-inbox fa-3x"></i>
                <p style={{ fontSize: '16px', marginTop: '20px' }}>
                  No hay muestras en este estado
                </p>
              </div>
            )}
          </DialogContent>
          
          <DialogActions sx={{ padding: '16px', backgroundColor: '#f8f9fa' }}>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center',
              width: '100%'
            }}>
              <div style={{ fontSize: '14px', color: '#666' }}>
                <i className="fa fa-info-circle"></i> 
                Mostrando {aplicarFiltros().length} de {muestrasDetalleCompletas.length} muestras en estado: <strong>{estadoSeleccionadoDetalle?.estado}</strong>
              </div>
              <Button 
                onClick={handleCerrarDetalleEstado}
                variant="contained"
                color="primary"
              >
                Cerrar
              </Button>
            </div>
          </DialogActions>
        </Dialog>

        {/* Modal de Histórico - Replica exacta de TomaMuestra */}
        <Dialog
          open={modalHistorialMuestraOpen}
          onClose={handleCerrarHistorialMuestra}
          maxWidth="lg"
          fullWidth
        >
          <DialogTitle>
            Histórico de Estados - {datosMuestraHistorial?.tipoMuestra || 'Cultivo por Salmonella'}
            <Typography variant="subtitle2" color="textSecondary">
              Muestra: {datosMuestraHistorial?.id || 'HECES'} | Módulo: {datosMuestraHistorial?.modulo || 'BACTERIOLOGIA'}
            </Typography>
          </DialogTitle>
          <DialogContent>
            {historialMuestraSeleccionada && historialMuestraSeleccionada.length > 0 ? (
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 'bold', minWidth: 120 }}>Fecha Cambio</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Estado Anterior</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Estado Nuevo</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', minWidth: 100 }}>Usuario</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Criterio Incumple</TableCell>
                      <TableCell sx={{ fontWeight: 'bold', minWidth: 150 }}>Comentario</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historialMuestraSeleccionada.map((item, index) => (
                      <TableRow 
                        key={index}
                        sx={{
                          '&:nth-of-type(odd)': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          },
                        }}
                      >
                        <TableCell>
                          <Typography variant="body2">
                            {item.fecha_cambio_estado ? new Date(item.fecha_cambio_estado).toLocaleString('es-ES', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            }) : '-'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={item.id_estado_anteriorNavigation?.estado || 'Estado inicial'} 
                            size="small"
                            color="default"
                            variant="outlined"
                          />
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={item.id_estado_nuevoNavigation?.estado || 'N/A'} 
                            size="small"
                            color={
                              item.id_estado_nuevo === 1 ? 'default' :
                              item.id_estado_nuevo === 2 ? 'primary' :
                              item.id_estado_nuevo === 3 ? 'success' :
                              item.id_estado_nuevo === 4 ? 'warning' :
                              item.id_estado_nuevo === 5 ? 'info' : 
                              item.id_estado_nuevo === 9 ? 'error' : 'default'
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {item.cambiado_por ? item.cambiado_por.trim() : '-'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ maxWidth: 150, wordWrap: 'break-word' }}>
                            {item.criterioIncumple || item.criterio_incumple || 'N/A'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" sx={{ maxWidth: 200, wordWrap: 'break-word' }}>
                            {item.comentario ? item.comentario.trim() : 'Sin comentarios'}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography variant="body1" color="textSecondary">
                  No hay historial disponible para esta muestra.
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  El histórico se generará cuando se realicen cambios de estado.
                </Typography>
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCerrarHistorialMuestra} variant="contained">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>

        {/* Menu de selección de columnas */}
        <Menu
          anchorEl={anchorElColumnas}
          open={Boolean(anchorElColumnas)}
          onClose={handleCerrarMenuColumnas}
          PaperProps={{
            style: {
              maxHeight: '500px',
              width: '350px',
            },
          }}
        >
          <MenuItem disabled>
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                Seleccionar Columnas
              </Typography>
              <Chip 
                label={`${columnasSeleccionadas.length} de ${columnasDisponibles.length}`}
                size="small"
                color="primary"
                sx={{ fontSize: '10px', height: '20px' }}
              />
            </Box>
          </MenuItem>
          <Divider />
          
          {/* Botones de acción rápida */}
          <MenuItem>
            <Box sx={{ width: '100%', display: 'flex', gap: 1, justifyContent: 'space-between' }}>
              <Button 
                size="small" 
                variant="outlined" 
                onClick={handleSeleccionarTodasColumnas}
                sx={{ fontSize: '10px', flex: 1 }}
              >
                Todas
              </Button>
              <Button 
                size="small" 
                variant="outlined" 
                onClick={handleRestablecerColumnas}
                sx={{ fontSize: '10px', flex: 1 }}
              >
                Por Defecto
              </Button>
            </Box>
          </MenuItem>
          <Divider />
          
          {/* Lista de columnas */}
          <Box sx={{ maxHeight: '350px', overflowY: 'auto' }}>
            {columnasDisponibles.map((columna) => (
              <MenuItem 
                key={columna.id}
                onClick={() => handleToggleColumna(columna.id)}
                sx={{ 
                  padding: '8px 16px',
                  '&:hover': {
                    backgroundColor: isColumnaSeleccionada(columna.id) ? 'rgba(25, 118, 210, 0.12)' : 'rgba(0, 0, 0, 0.04)'
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Checkbox
                      checked={isColumnaSeleccionada(columna.id)}
                      size="small"
                      disabled={columnasSeleccionadas.length === 1 && isColumnaSeleccionada(columna.id)}
                      sx={{ padding: 0 }}
                    />
                    <Typography variant="body2" sx={{ fontSize: '13px' }}>
                      {columna.label}
                    </Typography>
                  </Box>
                  {columna.enabled && (
                    <Chip 
                      label="Default"
                      size="small"
                      variant="outlined"
                      sx={{ fontSize: '9px', height: '18px' }}
                    />
                  )}
                </Box>
              </MenuItem>
            ))}
          </Box>
          
          <Divider />
          <MenuItem disabled>
            <Typography variant="caption" color="textSecondary" sx={{ fontSize: '11px' }}>
              <i className="fa fa-info-circle"></i> Al menos una columna debe estar seleccionada
            </Typography>
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};

const KanbanTomaMuestra = () => {
  return <KanbanTomaMuestrasInternal />;
};

export default KanbanTomaMuestra;